// Motion follows the device preference, without another switch in the child's UI.
export function motionEnabled(): boolean {
  return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
